import { ReactComponent as DashboardIcon } from "../assets/icons/menu/dashboard-icon.svg";
import { ReactComponent as UsersIcon } from "../assets/icons/menu/users-icon.svg";
import { ReactComponent as ArticlesIcon } from "../assets/icons/menu/articles-icon.svg";
import { ReactComponent as CommunityIcon } from "../assets/icons/menu/community.icon.svg";
import { ReactComponent as DropLocationsIcon } from "../assets/icons/menu/drop-locations.icon.svg";
import { FormSelect, MenuItem } from "../components";
import { useLeftMenu } from "../store/useLeftMenu";
import { useDropLocations } from "../store/useDropLocations";
import { useCurrentLocation } from "../store/useCurrentLocation";
import { useEffect } from "react";

const MenuHeader = ({ text }: { text: string }) => {
  return (
    <p className="text-xs font-medium select-none cursor-default underline-offset-2">
      {text}
    </p>
  );
};

export function Menu() {
  /** Hooks */
  const { isOpen, setIsOpen } = useLeftMenu();
  const { dropLocations, getDropLocations } = useDropLocations();
  const { currentLocation, setCurrentLocation } = useCurrentLocation();

  useEffect(() => {
    getDropLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <aside
      className={`flex flex-col rounded-xl [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden h-dvh w-full sm:w-72 absolute sm:fixed z-50  top-0 left-0 overflow-y-auto ${
        isOpen ? "flex" : "hidden sm:table-cell"
      }`}
    >
      <div className="w-full py-6 px-7  sm:flex hidden bg-droppie-lichtblauw  items-center justify-start gap-4">
        <img
          src="/Droppie.webp"
          alt="Droppie Logo"
          className="w-16 rounded h-16"
        />
        <span className="text-2xl font-default font-bold text-gray-800 hidden sm:table-cell">
          Droppie {process.env.REACT_APP_ENV === "production" ? "" : "DEV"}
        </span>
      </div>
      <div className="flex sm:hidden flex-row items-center mt-20">
        <FormSelect
          inputClassName="h-[38px] px-2 bg-sky-lighter text-sm"
          // @ts-ignore
          options={[
            { value: "all", label: "All locations" },
            // @ts-ignore
            ...(dropLocations?.map((location) => ({
              value: location?._id as string,
              label: location?.cost_place as string,
            })) ?? []),
          ]}
          value={currentLocation as string}
          onChange={(e) => {
            setIsOpen(false);
            setCurrentLocation(e.target.value);
          }}
          placeholder="Change location here..."
        />
      </div>

      {/* first column - Reporting */}
      <div className="mb-1 bg-droppie-lichtblauw w-full px-7 rounded-b-lg py-4">
        <MenuHeader text="Reporting" />

        <MenuItem
          lightBackground
          label="Summary "
          path="/"
          SvgIcon={DashboardIcon}
          className="mt-2"
          userRoles={["1", "5", "2", "4", "7"]}
        />
        {/* <MenuItem
          lightBackground
          label="Summary Metrics"
          path="/"
          SvgIcon={DashboardIcon}
          className="mt-2"
          userRoles={["1", "5", "2", "4", "7"]}
          subMenus={[
            {
              label: "Impact metrics",
              path: "/impact-metrics",
              SvgIcon: DashboardIcon,
              userRoles: ["1", "5", "2", "4", "7"],
            },
            {
              label: "Summary Graphs",
              path: "/summary-dashboard",
              icon: require("../assets/icons/menu/statiegeld.png"),
              userRoles: ["1", "5", "7"],
            },
          ]}
        /> */}

        <MenuItem
          lightBackground
          label="Volumes "
          path="/volumes"
          icon={require("../assets/icons/menu/volume-and-revenues-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        />
        <MenuItem
          lightBackground
          label="Revenues "
          path="/revenues"
          icon={require("../assets/icons/menu/revenues-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        />
        <MenuItem
          lightBackground
          label="Users "
          path="/users-v2"
          icon={require("../assets/icons/menu/users-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        />
        <MenuItem
          lightBackground
          label="Payments "
          path="/payments"
          icon={require("../assets/icons/menu/payment.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        />
        {/* <MenuItem
          lightBackground
          label="Store ops. (EMPTY)"
          path="/store-ops"
          icon={require("../assets/icons/menu/gear.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        /> */}
        {/* <MenuItem
          lightBackground
          label="User Data"
          path="/users"
          SvgIcon={UsersIcon}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "User Payments",
              path: "/withdraws",
              icon: require("../assets/icons/menu/withdraw-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Users Stats",
              path: "/new-user-stats",
              icon: require("../assets/icons/menu/stats-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            // {
            //   label: "Conversion Stats",
            //   path: "/conversion-stats-new",
            //   icon: require("../assets/icons/menu/stats-icon.png"),
            //   userRoles: ["1", "5", "2", "7"],
            // },
            {
              label: "Lead Sources",
              path: "/leading-sources",
              icon: require("../assets/icons/menu/leading-source.png"),
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        /> */}

        <MenuItem
          lightBackground
          label="Parcel report"
          path="/parcel-report"
          icon={require("../assets/icons/menu/parcel-icon.png")}
          className="mt-2"
          // Store admins (5) see their own store only; the backend pins it.
          userRoles={["1", "5", "2", "7"]}
        />

        <MenuItem
          lightBackground
          label="Plastic Dashboard"
          path="/plastic-dashboard/conversion"
          icon={require("../assets/icons/menu/stats-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "6", "7"]}
          subMenus={[
            {
              label: "Conversion",
              path: "/plastic-dashboard/conversion",
              icon: require("../assets/icons/menu/stats-icon.png"),
              userRoles: ["1", "5", "2", "6", "7"],
            },
            {
              label: "Volumes",
              path: "/plastic-dashboard/volumes",
              icon: require("../assets/icons/menu/volume-and-revenues-icon.png"),
              userRoles: ["1", "5", "2", "6", "7"],
            },
          ]}
        />
      </div>
      {/* second column - Zalm (beige) */}
      <div className="bg-droppie-zalm rounded-lg mb-1 w-full px-7 py-4">
        <MenuHeader text="Dashboard management" />

        <MenuItem
          lightBackground
          label="User logs"
          path="/users"
          icon={require("../assets/icons/menu/users-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "User Payments",
              path: "/withdraws",
              icon: require("../assets/icons/menu/withdraw-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Transaction Logs",
              path: "/transaction-logs",
              icon: require("../assets/icons/menu/withdraw-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Lead Sources",
              path: "/leading-sources",
              icon: require("../assets/icons/menu/leading-source.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Merge Accounts",
              path: "/merge-accounts",
              icon: require("../assets/icons/menu/merge.png"),
              userRoles: ["7"],
            },
            {
              label: "Account Review",
              path: "/account-review",
              icon: require("../assets/icons/menu/account-review.png"),
              userRoles: ["7"],
            },
            {
              label: "Pending Deletions",
              path: "/pending-deletions",
              icon: require("../assets/icons/menu/pending-deletion.png"),
              userRoles: ["1", "7"],
            },
          ]}
        />

        <MenuItem
          lightBackground
          label="Drops data"
          path="/drops-data"
          icon={require("../assets/icons/menu/hand.png")}
          // className="mt-2 [&_img]:h-8 [&_img]:w-8"
          userRoles={["1", "5", "2", "7"]}
        />
        <MenuItem
          lightBackground
          label="Statiegeld/DRP"
          path="/tomra-drops"
          icon={require("../assets/icons/menu/bottle.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            // {
            //   label: "Statiegeld Stats",
            //   path: "/new-statiegeld-stats",
            //   icon: require("../assets/icons/menu/statiegeld.png"),
            //   userRoles: ["1", "5", "7"],
            // },
            {
              label: "Products",
              path: "/statiegeld-products",
              icon: require("../assets/icons/menu/statiegeld.png"),
              userRoles: ["1", "5", "7"],
            },
            // {
            //   label: "Drops",
            //   path: "/tomra-drops",
            //   icon: require("../assets/icons/menu/statiegeld.png"),
            //   userRoles: ["1", "5", "2", "7"],
            // },
            {
              label: "Machines",
              path: "/tomra-machines",
              icon: require("../assets/icons/menu/statiegeld.png"),
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        />
        <MenuItem
          lightBackground
          label="Beevision/Dropbot"
          path="/beevision-drops"
          icon={require("../assets/icons/menu/dropbot-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "Machines",
              path: "/beevision-machines",
              icon: require("../assets/icons/menu/dropbot-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Audit Logs",
              path: "/beevision-audit-logs",
              icon: require("../assets/icons/menu/dropbot-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        />

        <MenuItem
          lightBackground
          label="Mobile analytics"
          path={"/mobile-analytics"}
          icon={require("../assets/icons/menu/smartphone.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        />
        <MenuItem
          lightBackground
          label="Materials"
          path={"/market-pricing"}
          SvgIcon={UsersIcon}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={
            [
              // {
              //   label: "Drops Data",
              //   path: "/drops",
              //   SvgIcon: DropsIcon,
              //   userRoles: ["1", "5", "2", "7"],
              // },
              // {
              //   label: "Drop Stats",
              //   path: "/drops-stats",
              //   icon: require("../assets/icons/menu/stats-icon.png"),
              //   userRoles: ["1", "5", "2", "7"],
              // },
              // {
              //   label: "Stream Economics",
              //   path: "/market-pricing",
              //   SvgIcon: MarketPricingIcon,
              //   userRoles: ["1", "5", "7"],
              // },
              // {
              //   label: "Feedback",
              //   path: "/material-feedback",
              //   icon: require("../assets/icons/menu/feedback.png"),
              //   userRoles: ["1", "5", "2", "7"],
              // },
            ]
          }
        />

        <MenuItem
          lightBackground
          label="Locations"
          path="/drop-locations"
          SvgIcon={DropLocationsIcon}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        />

        <MenuItem
          lightBackground
          label="Partners"
          path="/partners"
          icon={require("../assets/icons/menu/partner-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              // Only ADMIN and SUPER_ADMIN may mark a partner as a carrier -
              // the backend strips the flag from anyone else's payload - so
              // the page that creates them is theirs.
              label: "Carrier partners",
              path: "/carrier-partners",
              icon: require("../assets/icons/menu/carrier-icon.png"),
              userRoles: ["1", "7"],
            },
            {
              // Backoffice-only: matches the backend role gate on
              // /partners/vouchers/pending-codes (ADMIN + SUPER_ADMIN,
              // EMPLOYEE and STORE_ADMIN excluded).
              label: "Voucher codes",
              path: "/pending-voucher-codes",
              icon: require("../assets/icons/menu/voucher.png"),
              userRoles: ["1", "7"],
            },
          ]}
        />

        <MenuItem
          lightBackground
          label="Communities"
          path="/community"
          SvgIcon={CommunityIcon}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "Donations",
              path: "/donations",
              icon: require("../assets/icons/menu/donation-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        />

        <MenuItem
          lightBackground
          label="Parcels"
          path="/parcels"
          icon={require("../assets/icons/menu/parcel-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              // Individual customer handoffs — separate from the bulk parcel
              // statistics the parent entry shows.
              label: "Parcel Handoffs",
              icon: require("../assets/icons/menu/parcel-icon.png"),
              path: "/parcel-handoffs",
              // No EMPLOYEE (2): this page is a searchable index of customer
              // names and email addresses, which counter staff have no need
              // of. The backend refuses them the endpoint too.
              userRoles: ["1", "5", "7"],
            },
          ]}
        />
      </div>

      {/* third column - Lichtpaars (light purple) for black text */}
      <div className="bg-droppie-lichtpaars rounded-lg mb-1 w-full px-7 py-4">
        <MenuHeader text="App operations" />

        <MenuItem
          lightBackground
          label="Webhook Simulator"
          path="/simulator"
          icon={require("../assets/icons/menu/test-icon.png")}
          className="mt-2"
          userRoles={["7"]}
        />

        <MenuItem
          lightBackground
          label="Communications"
          path="/notifications"
          icon={require("../assets/icons/menu/app-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "Articles",
              path: "/articles",
              SvgIcon: ArticlesIcon,
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Notifications",
              path: "/notifications",
              SvgIcon: CommunityIcon,
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Dropbot AD",
              path: "/dropbot-loading-ad",
              icon: require("../assets/icons/menu/dropbot-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Onboardings",
              path: "/onboardings",
              icon: require("../assets/icons/menu/onboarding.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            // {
            //   label: "Users Profiles",
            //   path: "/user-profile-badges",
            //   icon: require("../assets/icons/menu/user-profile-badge.png"),
            //   userRoles: ["1", "5", "2", "7"],
            // },
          ]}
        />
        <MenuItem
          lightBackground
          label="Recycling info"
          path="/appinfo"
          icon={require("../assets/icons/menu/recycle.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
        />
        <MenuItem
          lightBackground
          label="How it works"
          path="/how-it-works"
          icon={require("../assets/icons/menu/recycle.png")}
          className="mt-2"
          userRoles={["1", "7"]}
        />

        <MenuItem
          lightBackground
          label="Lotteries"
          path="/lottery"
          icon={require("../assets/icons/menu/lottery-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "Vouchers",
              path: "/lottery-vouchers",
              icon: require("../assets/icons/menu/voucher.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Result messages",
              path: "/lottery-notifications",
              icon: require("../assets/icons/menu/notification-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        />

        <MenuItem
          lightBackground
          label="Challenges"
          icon={require("../assets/icons/menu/challenges-icon.png")}
          path="/partner-challenges"
          userRoles={["1", "5", "2", "7"]}
          className="mt-2"
          subMenus={[
            {
              label: "Vouchers",
              path: "/challenge-vouchers",
              icon: require("../assets/icons/menu/voucher.png"),
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        />
        {/* <MenuItem
          lightBackground
          label="Quality"
          path="/quality-inputs"
          icon={require("../assets/icons/menu/quality-input-icon.png")}
          className="mt-2"
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "Plastics",
              icon: require(".././assets/icons/menu/quality-input-icon.png"),
              path: "/quality-inputs/plastics",
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Data Carrier",
              icon: require(".././assets/icons/menu/data-carrier-icon.png"),
              path: "/data-carriers",
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        /> */}
      </div>

      <div className="rounded-lg w-full px-7 py-4">
        <MenuItem
          lightBackground
          label="Graveyard"
          path="/graveyard"
          className="mt-2 !text-white"
          icon={require("../assets/icons/menu/tombstone.png")}
          userRoles={["1", "5", "2", "7"]}
          subMenus={[
            {
              label: "Users Stats",
              path: "/new-user-stats",
              icon: require("../assets/icons/menu/stats-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "Benchmarking Graphs",
              path: "/benchmarking-graphs",
              icon: require("../assets/icons/menu/drop-locations.png"),
              userRoles: ["1", "5", "2", "7"],
            },
            {
              label: "KPIs",
              path: "/kpi-screen",
              icon: require("../assets/icons/menu/stats-icon.png"),
              userRoles: ["1", "5", "2", "7"],
            },
          ]}
        />
      </div>
    </aside>
  );
}
